/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyProfileIdQueryVariables = Types.Exact<{ [key: string]: never }>;

export type LoyaltyProfileIdQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename: 'LoyaltyProfile';
    readonly loyaltyId: string | null;
    readonly customerId: string;
  } | null;
};

export const LoyaltyProfileIdDocument = gql`
  query LoyaltyProfileId {
    loyaltyProfile {
      __typename
      ... on LoyaltyProfile {
        loyaltyId
        customerId
      }
    }
  }
`;

export function useLoyaltyProfileIdQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyProfileIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyProfileIdQuery, LoyaltyProfileIdQueryVariables>({
    query: LoyaltyProfileIdDocument,
    ...options,
  });
}
